import { AccessPolicy, UserRole } from './AccessControl'
import { Repository as RepositoryWithNumberId } from './Repository'

export interface Repository {
  id: string
  name: string
  status?: string
  createdAt?: string
  updatedAt?: string
  type: string
}

export interface Organization extends Repository {
  domain: string
}

export interface Client extends Repository {
  organization_id: number
  //Project: Project[]
}

export interface Project extends Repository {
  description: string
  address: string
  startDate: string
  endDate: string
  primaryContact: string
  client_id: string
  organization_id: number
  //File: File[]
}

export interface File extends RepositoryWithNumberId {
  path: string
  name: string
  thumbnail_path: string
  project_id: string
  //project: Project
}

export interface User {
  id: number
  email: string
  phone_number: string
  organization_id: number
  user_name: string
  role: UserRole
  role_id: string
  createdAt?: string
  updatedAt?: string
}

export interface UserRecentFile extends Repository {
  user_id: string
  file_id: string
  file: File
}

export enum OrganizationType {
  ARCHITECT = 'Architect',
  ENGINEER = 'Engineer',
}
